import { format } from 'date-fns';
import { getAllRanges } from '../../services/LightweightFilters/LightweightFiltersRangesService';
import type { NewDateRangeInfo } from '../../types/dateRangeTypes';

/*
 * (date-fns equivalent of DEFAULT_DATE_FORMAT)
 * default for how the dashboard stores dates internally (i.e. when the program executes, not what is necessarily displayed to the user).
 *
 * '2018-05-09'
 */
export const DEFAULT_DATE_FORMAT_DATE_FNS = 'yyyy-MM-dd';
export const SHORT_DATE_FORMAT_DATE_FNS = 'MMM dd, yyyy';

export const formatToDefaultDateFormat = (date: Date): string => {
  return format(date, DEFAULT_DATE_FORMAT_DATE_FNS);
};

export const handleGetNewDateRangeInfo = (dateRangeInfo: Partial<NewDateRangeInfo>): NewDateRangeInfo => {
  const allDefaultRanges = getAllRanges();
  const defaultRange = dateRangeInfo.defaultRange || 'custom';

  if (defaultRange === 'custom') {
    const { dateRange } = dateRangeInfo;
    const startDate = dateRange?.start_date || formatToDefaultDateFormat(new Date());
    const endDate = dateRange?.end_date || formatToDefaultDateFormat(new Date());

    return {
      dateRange: {
        start_date: startDate,
        end_date: endDate,
      },
      defaultRange,
    };
  }

  const calculatedDateRange = allDefaultRanges.find((range) => range.type === defaultRange)?.getValue();
  const startDate = formatToDefaultDateFormat((calculatedDateRange && calculatedDateRange[0]) || new Date());
  const endDate = formatToDefaultDateFormat((calculatedDateRange && calculatedDateRange[1]) || new Date());

  return {
    dateRange: {
      start_date: startDate,
      end_date: endDate,
    },
    defaultRange,
  };
};
